/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Tabs, Tab, Form, Card } from "react-bootstrap";
import Select from "../../common-components/select/Select.jsx";
import "./code-conversion.scss";
import InputField from "../../common-components/input-field/Input-field.jsx";
import { modelOptions, sourceOptions, targetOptions, dataUploadOptions } from "./conversion-options.js";
import CustomButton from "../../common-components/button/Button.jsx";
import { useDispatch, useSelector } from "react-redux";
import { convertCode, clearState, iteration, bteqCodeSummary, githubLink, setSelectedFileResponse, bteqCodeConversionChunk, updateClonedRepo, setFileContent } from "../../state/reducers/codeConversion.js";
import { setInlineLoader } from "../../state/reducers/common";
import SyntaxHighlighter from "react-syntax-highlighter";
import { github } from "react-syntax-highlighter/dist/esm/styles/hljs";
import ReactMarkdown from "react-markdown";
import { Scrollbars } from "react-custom-scrollbars-2";
import CustomModal from "../../common-components/modal/Modal.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard, faDownload, faCheck, faPlus, faChevronRight, faChevronLeft, faTimes, faPaperclip } from "@fortawesome/free-solid-svg-icons";
import FolderStructure from "../../common-components/folderStructure/FolderStructure.jsx";
import Stepper from "../../common-components/stepper/Stepper.jsx";
import Banner from "../../common-components/banner/Banner.jsx";
import bannerMessages from "../../common/bannerMessage.js";
import TextAreaField from "../../common-components/input-field/Text-area-field.jsx";
import { X, FileText } from "lucide-react";
import { Link } from "react-router-dom";

const customStyle = {
  backgroundColor: "#fff"
};

function CodeConversion() {
  const [uploadOption, setUploadOption] = useState("");
  const [sourceLanguage, setSourceLanguage] = useState("");
  const [targetLanguage, setTargetLanguage] = useState("");
  const [modalShow, setModalShow] = React.useState(false);
  const [cloneRepoModal, setCloneRepoModal] = React.useState(false);
  const [enableGithubClone, setEnableGithubClone] = React.useState(false);
  const [tdd, setTdd] = useState(false);
  const [file, setFile] = useState([]);
  const [images, setImages] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [model, setModel] = useState("");
  const [prompt, setPrompt] = useState("");
  const [iterationValue, setIteration] = useState(1);
  const [errors, setErrors] = useState({});
  const [copied, setCopied] = useState(false);
  const [githubUrl, setGithubUrl] = useState("");
  const [fileError, setFileError] = useState("");
  const [fileInputKey, setFileInputKey] = useState(0);
  const [isFileInputDisabled, setIsFileInputDisabled] = useState(true);
  const [chunkFiles, setChunkFiles] = useState([]);
  const [showImageModal, setShowImageModal] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [bannerMessage, setBannerMessage] = useState();
  const dispatch = useDispatch();
  const targetCode = useSelector((state) => state.codeConversion.targetCode);
  const judgeResponse = useSelector((state) => state.codeConversion.judgeResponse);
  const validationMessage = useSelector((state) => state.codeConversion.validationMessage);
  const iterationCheck = useSelector((state) => state.codeConversion.iteration)
  const createdTdd = useSelector((state) => state.codeConversion.tdd)
  const bteqChange = useSelector((state) => state.codeConversion.bteqChange)
  const clonedRepo = useSelector((state) => state.codeConversion.clonedRepo)
  const apiCount = useSelector((state) => state.common.apiCount);
  const user = useSelector((state) => state.auth.user);
  const fileContent = useSelector((state) => state.codeConversion.fileContent)
  const loadingMessage = useSelector((state) => state.codeConversion.loadingMessage)
  const fileInputRef = useRef(null);

  useEffect(() => {
    setModalShow(false);
  }, []);

  useEffect(() => {
    if(sourceLanguage && targetLanguage){
      setBannerMessage(bannerMessages.find(banner => banner.sourceLanguage === sourceLanguage && banner.targetLanguage === targetLanguage))
    } else{
      setBannerMessage(undefined)
    }
  }, [sourceLanguage, targetLanguage])

  useEffect(() => {
    if(clonedRepo.length > 1)
      setCloneRepoModal(true)
  }, [clonedRepo])

  const isValidFileExtension = (filename, expectedExtensions) => {
    const extension = filename.split(".").pop().toLowerCase();
    return expectedExtensions.includes(extension);
  };

  const validateFiles = (files, lang) => {
    const sourceLanguageOption = sourceOptions.find(option => option.value === lang);
    const expectedExtensions = sourceLanguageOption ? sourceLanguageOption.options.extension.split(", ").map(ext => ext.trim()) : [];

    if (expectedExtensions.length === 0) {
      setFileError("Please select a valid source.");
      return { validFiles: [], invalidFiles: [] };
    }

    let invalidFiles = [];
    let validFiles = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (isValidFileExtension(file.name, expectedExtensions)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    }

    return { validFiles, invalidFiles };
  };

  const handlePrev = () => {
    if (currentImageIndex > 0) {
      setCurrentImageIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentImageIndex < images.length - 1) {
      setCurrentImageIndex((prev) => prev + 1);
    }
  };

  const handleRemoveImage = (index) => {
    if (images.length === 0 || index < 0 || index >= images.length) return;
  
    const updatedImages = images.filter((_, i) => i !== index);

    setImages(updatedImages);
  
    setCurrentImageIndex((prev) => {
      if (updatedImages.length === 0) return 0; 
      return prev >= updatedImages.length 
        ? updatedImages.length - 1 
        : prev;
    });
  };

  const handleImageUpload = (event) => {
    const files = event.target.files; // Access uploaded files
    const imagePreviews = [];

    // Loop through each uploaded file
    Array.from(files).forEach((file) => {
      const reader = new FileReader();
      reader.onload = () => {
        imagePreviews.push(reader.result); // Push Base64 string to the array
        if (imagePreviews.length === files.length) {
          setImages((prev) => [...prev, ...imagePreviews]); // Update state after all files are read
        }
      };
      reader.readAsDataURL(file); // Convert file to Base64
    });
  };

  const handleFileChange = (event) => {
    const files = event.target.files;
  
    if (!sourceLanguage) {
      setFileError("Please select a source before uploading files.");
      setFileInputKey(prevKey => prevKey + 1); // Reset file input
      return;
    }
  
    // Find the source language group and specific option
    const sourceLanguageGroup = sourceOptions.find(group => 
      group.options.some(option => option.value === sourceLanguage)
    );
    
    const languageOption = sourceLanguageGroup?.options.find(option => 
      option.value === sourceLanguage
    );
  
    if (!languageOption || !languageOption.extension) {
      setFileError("Invalid source selected or missing extension configuration.");
      return;
    }
  
    const expectedExtensions = languageOption.extension.split(", ").map(ext => ext.trim());
  
    let validFiles = [];
    let invalidFiles = [];
  
    Array.from(files).forEach(file => {
      const extension = file.name.split(".").pop().toLowerCase();
      if (expectedExtensions.includes(extension)) {
        validFiles.push(file);
      } else {
        invalidFiles.push(file.name);
      }
    });
  
    if (invalidFiles.length > 0) {
      setFileError(`Invalid file type(s): ${invalidFiles.join(", ")}. Please upload ${expectedExtensions.join(", ")} files for ${sourceLanguage}.`);
    } else {
      setFileError("");
    }
  
    setFile(validFiles);
    
    const validFileContents = [];
    validFiles.forEach(file => {
      const reader = new FileReader();
      reader.onload = function(e) {
        let steps = [];
        for(let i=1; i<= iterationValue; i++){
          steps.push({
            label: i,
            name: `Iteration ${i}`,
            key: i,
            status: "pending"
          });
        }
        validFileContents.push({
          name: file.name,
          content: e.target.result,
          currentIteration: 1,
          iterations: steps
        });
        if (validFileContents.length === validFiles.length) {
          dispatch(setFileContent(validFileContents));
          setRefresh(!refresh);
        }
      };
      reader.readAsText(file);
    });
  };

  const handleSourceLanguageChange = (e) => {
    const newSourceLanguage = e.target.value;
    setSourceLanguage(newSourceLanguage);
    setTargetLanguage("");
    setIsFileInputDisabled(false);

    // Re-validate existing files when source language changes
    if (file && file.length > 0) {
      const { validFiles, invalidFiles } = validateFiles(file, newSourceLanguage);
      
      if (invalidFiles.length > 0) {
        const sourceLanguageOption = sourceOptions.find(option => option.value === newSourceLanguage);
        const allowedExtensions = sourceLanguageOption ? sourceLanguageOption.options.extension : "";
        setFileError(`Invalid file type(s) for the new source: ${invalidFiles.join(", ")}. Please upload ${allowedExtensions} files for ${newSourceLanguage}.`);
        setFile([]);
        dispatch(setFileContent([]));
        dispatch(clearState())
      } else {
        setFileError("");
        setFile(validFiles);
      }
    }
    
    setFileInputKey(prevKey => prevKey + 1); // Reset file input
  };

  const validateFields = (type) => {
    const newErrors = {};
    if (!uploadOption) newErrors.uploadOption = "File source option is required";
    if (!sourceLanguage) newErrors.sourceLanguage = "Source is required";
    if (!targetLanguage) newErrors.targetLanguage = "Target is required";
    if (sourceLanguage == targetLanguage) newErrors.targetLanguage = "Source and Target cannot be the same"
    if (type != "github" && !file) newErrors.file = "File upload is required";
    if (type == "github" && !githubUrl) newErrors.file = "Github URL is required";
    if (!model) newErrors.model = "Model is required";

    // Add file extension validation
    if (file && file.length > 0) {
      const sourceLanguageOption = sourceOptions.find(option => option.value === sourceLanguage);
      const expectedExtension = sourceLanguageOption ? sourceLanguageOption.options.extension : null;
      if (expectedExtension) {
        const invalidFiles = Array.from(file).filter(f => !isValidFileExtension(f.name, expectedExtension));
        if (invalidFiles.length > 0) {
          newErrors.file = `Invalid file type(s): ${invalidFiles.map(f => f.name).join(", ")}. Please upload ${expectedExtension} files for ${sourceLanguage}.`;
        }
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const codeConversionChunk = () => {
    const payload = {
      source_language: sourceLanguage,
      target_language: targetLanguage,
      source_files: chunkFiles,
      selected_model: model,
      iteration_count: iterationValue,
      user_prompt: prompt,
      username: JSON.parse(localStorage.getItem("user"))?.username
    };
    dispatch(bteqCodeConversionChunk(payload))
  }

  const codeConversion = () => {
    if (validateFields()) {
      const payload = {
        source_language: sourceLanguage,
        target_language: targetLanguage,
        source_files: file,
        user: user.username,
        model: model,
        tdd_required: tdd,
        user_prompt: prompt
      };
      sessionStorage.setItem(
        "code-conversion",
        JSON.stringify({
          uploadOption,
          sourceLanguage,
          targetLanguage,
          file,
          fileContent,
          model,
          iterationValue,
          tddRequired: tdd
        })
      );
      if(sourceLanguage === "bteq"){
        dispatch(bteqCodeSummary({
          source_files: file,
          iteration: iterationValue
        }))
      } else {
        dispatch(setInlineLoader(true))
        dispatch(convertCode(payload))
      }
    }
  };

  useEffect(() => {
    let payload = {
      source_language: sourceLanguage,
      target_language: targetLanguage,
      selected_model: model,
      user: JSON.parse(localStorage.getItem("user"))?.username,
      files: [],
      iteration: fileContent[0]?.currentIteration
    };
    console.log("Payload: ", payload, fileContent);
    fileContent?.map(content => {
      if(content.currentIteration <= iterationValue && content.message == "Failure"){
        const previousIteration = content.iterations.find(iter => iter.iteration == content.currentIteration - 1)
        console.log("Previous Iteration: ", previousIteration, iterationValue, content)
        payload.files.push({
          source_code: content?.source_code || previousIteration.source_code,
          initial_target_code: previousIteration.target_code,
          initial_judge_response: previousIteration.judge_response,
          filename: content?.name
        })
      }
    })
    if(payload.files.length > 0){
      dispatch(setInlineLoader(true))
      dispatch(iteration(payload))
    }
  }, [iterationCheck])

  const resetFields = () => {
    setUploadOption("");
    setSourceLanguage("");
    setTargetLanguage("");
    setFile("");
    setFileContent([]);
    setModel("");
    setIteration(1);
    setErrors({});
    setPrompt("");
    sessionStorage.removeItem("code-conversion");
    sessionStorage.removeItem("code-conversion-response");
    dispatch(clearState());
  };

  useEffect(() => {
    const chunkApiFiles = fileContent.filter(content => content.chunk === true);
    const convertApiFiles = fileContent.filter(content => content.chunk === false);
    if(chunkApiFiles.length > 0){
      const commonArray = file.filter(obj1 =>
        chunkApiFiles.some(obj2 => obj1.name === obj2.name)
      );
      console.log("Common Array: ", commonArray, file, chunkApiFiles)
      setChunkFiles(commonArray)
      dispatch(setInlineLoader(true))
      setModalShow(true);
    } 
    if(convertApiFiles.length > 0) {
      const commonArray = file.filter(obj1 =>
        convertApiFiles.some(obj2 => obj1.name === obj2.name)
      );
      console.log("Common Array: ", commonArray, file, convertApiFiles)
      const payload = {
        source_language: sourceLanguage,
        target_language: targetLanguage,
        source_files: commonArray,
        user: user.username,
        model: model,
        tdd_required: tdd,
        user_prompt: prompt
      };
      dispatch(setInlineLoader(true))
      dispatch(convertCode(payload))
    }
  }, [bteqChange])

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      // Reset the icon after 2 seconds
      setTimeout(() => {
        setCopied(false);
      }, 2000);
    }, (err) => {
      console.error("Could not copy text: ", err);
    });
  };

  const getSteps = (count) => {
    const steps = [];
    for(let i=1; i<= count; i++){
      steps.push({
        label: i,
        name: `Iteration ${i}`,
        key: i,
        status: "pending"
      })
    }
    const updatedContent = fileContent.map(file => {
      return {
        ...file,
        iterations: steps
      }
    })
    dispatch(setFileContent(updatedContent));
  }

  const cloneRepository = () => {
    dispatch(githubLink({
      repoPath: githubUrl,
      language: sourceLanguage
    }))
  }

  const handleCloseTab = (key) => {
    const files = fileContent
    const updated = files.filter(item => item !== key)
    dispatch(setFileContent(updated));
  };

  const downloadTargetCode = () => {
    const targetLanguageOption = targetOptions.find(option => option.value === targetLanguage);
    const fileExtension = targetLanguageOption ? targetLanguageOption.extension : "txt";
    
    const element = document.createElement("a");
    const file = new Blob([targetCode], {type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = `target_code.${fileExtension}`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const downloadTDD = () => {
    const element = document.createElement("a");
    const file = new Blob([createdTdd], {type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = "technical_design_document.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };
  
  const downloadJudge = () => {
    const element = document.createElement("a");
    const file = new Blob([judgeResponse], {type: "text/plain"});
    element.href = URL.createObjectURL(file);
    element.download = "judgeResponse.txt";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="page-wrapper code-conversion-page">
      <Container fluid>
        <Row>
          <Col>
            <div className="content-wrap">
              <h2 className="page-title">
                <span>Code Conversion</span>
                <Link to="/conversion-history">View Conversion History</Link>
              </h2>
              <div className="code-conversion-wrapper">
                <div className="conversion-form">
                  {bannerMessage &&
                    <Row className="mb-3">
                      <Col>
                        <Banner message={bannerMessage.message} icon={true} variant={bannerMessage.variant}/>
                      </Col>
                    </Row>
                  }
                  <Row className="mb-3">
                    <Col md={4}>
                      <Select 
                        value={uploadOption} 
                        options={dataUploadOptions} 
                        placeholder={"Select upload method"} 
                        label="File Source Options" 
                        id="upload-method" 
                        onChange={(e) => {
                          if(e.target.value === "github-link"){
                            setEnableGithubClone(true)
                            setFile([])
                            dispatch(setFileContent([]))
                            dispatch(clearState())
                          }
                          else if(e.target.value === "file-upload"){
                            setEnableGithubClone(false)
                            setFile([])
                            dispatch(setFileContent([]))
                            dispatch(clearState())
                          }
                          setUploadOption(e.target.value)}}
                        layoutStyle="vertical"
                        labelColSize={4}
                        inputColSize={8} 
                        required
                        validationMsg={errors.uploadOption}
                      />
                    </Col>
                    <Col md={4}>
                      <Select 
                        value={model} 
                        options={modelOptions} 
                        placeholder={"Select Model"} 
                        label="Model" 
                        id="model" 
                        onChange={(e) => setModel(e.target.value)}
                        layoutStyle="vertical"
                        labelColSize={4}
                        inputColSize={8} 
                        required
                        validationMsg={errors.model}
                      />
                    </Col>
                    <Col md={4}>
                      <InputField 
                        id="iterations" 
                        label="Feedback Iterations"
                        value={iterationValue} 
                        onChange={(e) => {
                          setIteration(e.target.value)
                          getSteps(e.target.value)
                        }}
                        layoutStyle="vertical"
                        labelColSize={4}
                        inputColSize={8} 
                      />
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={4}>
                      <Select 
                        value={sourceLanguage} 
                        options={sourceOptions} 
                        placeholder={"Select Source"} 
                        label="Source" 
                        id="source-language" 
                        onChange={handleSourceLanguageChange}
                        layoutStyle="vertical"
                        labelColSize={4}
                        inputColSize={8}
                        required
                        validationMsg={errors.sourceLanguage}
                      />
                    </Col>
                    <Col md={4}>
                      <Select 
                        value={targetLanguage} 
                        options={targetOptions} 
                        placeholder={"Select Target"} 
                        label="Target" 
                        id="target-language" 
                        onChange={(e) => setTargetLanguage(e.target.value)}
                        layoutStyle="vertical"
                        labelColSize={4}
                        inputColSize={8} 
                        required
                        validationMsg={errors.targetLanguage}
                        sourceLanguage={sourceLanguage}
                      />
                    </Col>
                    <Col md={4}>
                      {uploadOption === "file-upload" && 
                        <div>
                          <InputField
                            key={fileInputKey} 
                            forwardRef={fileInputRef} 
                            id="files" 
                            type="file" 
                            label="Upload Files" 
                            onChange={handleFileChange}
                            layoutStyle="vertical"
                            labelColSize={4}
                            inputColSize={8}
                            required
                            multiple
                            validationMsg={errors.file || fileError}
                            disabled={isFileInputDisabled}
                          />
                        </div>
                      }
                      {
                        uploadOption === "github-link" &&
                        <InputField 
                          id="github-link" 
                          label="GitHub Url"
                          value={githubUrl} 
                          onChange={(e) => setGithubUrl(e.target.value)}
                          layoutStyle="vertical"
                          labelColSize={4}
                          inputColSize={8}
                          required
                          validationMsg={errors.file}
                        />
                      }
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={12}>
                      <TextAreaField
                        id="prompt" 
                        label="Prompt"
                        value={prompt} 
                        onChange={(e) => setPrompt(e.target.value)}
                        layoutStyle="vertical"
                        labelColSize={4}
                        inputColSize={8}
                        validationMsg={errors.file}
                        attachIcon = {(<FontAwesomeIcon
                          icon={faPaperclip}
                          size="lg"
                          className="attach-icon"
                          onClick={() => setShowImageModal(true)}
                        />)}
                      />
                    </Col>
                  </Row>
                  {
                    sourceLanguage === "COBOL" &&
                    <Row className="mb-3">
                      <Col>
                        <Form>
                          <Form.Check
                            type="checkbox"
                            id="tdd"
                            label="Technical Design Document(TDD)"
                            checked={tdd}
                            onClick={(e) => setTdd(e.target.checked)}
                          />
                        </Form>
                      </Col>
                    </Row>
                  }
                  <Row className="mt-4">
                    <Col className="text-end">
                      {
                        enableGithubClone ?
                          <>
                            <CustomButton className="convert me-3" label="Clone Repo" onClick={() => {
                              if(validateFields("github")){
                                cloneRepository()
                              }
                            }} />
                            <CustomButton className="convert btn-secondary" label="Reset" onClick={resetFields} /> 
                          </>:
                          <>
                            <CustomButton className="convert me-3" label="Send Feedback" />
                            <CustomButton className="convert me-3" label="Start Conversion" onClick={() => codeConversion()} />
                            <CustomButton className="convert btn-secondary" label="Reset" onClick={resetFields} />
                          </>
                      }
                    </Col>
                  </Row>
                </div>
                {fileContent?.length > 0 && <Row>
                  <Col xs={12}>
                    <Tabs
                      defaultActiveKey={fileContent[0]?.name}
                      id="uncontrolled-tab-example"
                      className="file-tabs"
                      onSelect={(key) => {
                        dispatch(setSelectedFileResponse({
                          filename: key,
                          iteration: 1
                        }))
                      }}
                    >
                      {fileContent?.map((content, i) => (
                        <Tab key={i} eventKey={content.name} title={<div className="d-flex align-items-center">
                          {content.name}
                          <CustomButton
                            className="file-close me-3"
                            label={
                              <X size={16} strokeWidth={2} />
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCloseTab(content);
                            }}
                          />
                        </div>
                        }>
                          <>
                            {
                              content.chunk &&
                              <>
                                <div className="loading-message-stepper">{apiCount == 0 && loadingMessage}</div>
                              </>
                            }
                            {
                              !content.chunk && <>
                                <Row className="stepper-container mb-4">
                                  <Stepper data={content.iterations} 
                                    onChange={(value) => {
                                      console.log("Value: ", value)
                                      dispatch(setSelectedFileResponse({
                                        filename: content.name,
                                        iteration: Number(value)
                                      }))
                                    }}
                                  />
                                </Row>
                                <Row>
                                  {loadingMessage && <div className="loading-message-stepper">{loadingMessage}</div>}
                                </Row>
                              </>
                            }
                            {fileContent?.length > 0 &&
                <>
                  <Row className="mb-3">
                    <Col>
                      {validationMessage && validationMessage?.length > 0 &&
                        <div className="validation-message">{validationMessage}</div>
                      }
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <Tabs
                        defaultActiveKey="sourceCode"
                        id="uncontrolled-tab-example"
                        className="source-code-wrapper"
                      >
                        <Tab id="sourceCode" eventKey="sourceCode" title="Source Code">
                          <div className="tab-content-wrapper">
                            <Scrollbars autoHeight autoHeightMax={500}>
                              <SyntaxHighlighter language={sourceOptions.find(source => source.value === sourceLanguage)?.language} style={github} customStyle={customStyle} wrapLongLines={true}>
                                {content.content}
                              </SyntaxHighlighter>
                            </Scrollbars>
                          </div>
                        </Tab>
                      </Tabs>
                    </Col>
                    <Col xs={6}>
                      {targetCode &&
                        <Tabs
                          defaultActiveKey="targetCode"
                          id="uncontrolled-tab-example"
                          className="target-code-wrapper"
                        >
                          <Tab id="targetCode" eventKey="targetCode" title="Target Code">
                            <div className="tab-content-wrapper">
                              <button className="copy-btn" onClick={() => copyToClipboard(targetCode)}>
                                <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="copy-icon"/> <span>Copy</span>
                              </button>
                              <Scrollbars autoHeight autoHeightMax={500}>
                                <SyntaxHighlighter language={targetOptions.find(source => source.value === targetLanguage)?.language} customStyle={customStyle}  style={github} wrapLongLines={true}>
                                  {targetCode}
                                </SyntaxHighlighter>
                              </Scrollbars>
                            </div>
                            <button className="download-btn" onClick={downloadTargetCode}>
                              <FontAwesomeIcon icon={faDownload} className="dld-icon" /> <span>Download Code</span>
                            </button>
                          </Tab>
                          <Tab eventKey="judgeResponse" title="Automated Code Quality Assessment">
                            <div className="tab-content-wrapper">
                              <button className="copy-btn" onClick={() => copyToClipboard(judgeResponse)}>
                                <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="copy-icon"/> <span>Copy</span>
                              </button>
                              <Scrollbars autoHeight autoHeightMax={500}>
                                <ReactMarkdown>{judgeResponse}</ReactMarkdown>
                              </Scrollbars>
                            </div>
                            <button className="download-btn" onClick={downloadJudge}>
                              <FontAwesomeIcon icon={faDownload} className="dld-icon" /> <span>Download Code Quality</span>
                            </button>
                          </Tab>
                          {tdd && createdTdd && 
                          <Tab eventKey="tdd" title="TDD">
                            <div className="tab-content-wrapper">
                              <button className="copy-btn" onClick={() => copyToClipboard(createdTdd)}>
                                <FontAwesomeIcon icon={copied ? faCheck : faClipboard} className="copy-icon"/> <span>Copy</span>
                              </button>
                              <Scrollbars autoHeight autoHeightMax={500}>
                                <ReactMarkdown>{createdTdd}</ReactMarkdown>
                              </Scrollbars>
                            </div>
                            <button className="download-btn" onClick={downloadTDD}>
                              <FontAwesomeIcon icon={faDownload} className="dld-icon" /> <span>Download TDD</span>
                            </button>
                          </Tab>}
                        </Tabs>}
                    </Col>
                  </Row>
                </>
                            }
                          </>
                        </Tab>
                      ))}
                    </Tabs>
                  </Col>
                </Row>}
              </div>
            </div>
          </Col>
          
        </Row>
      </Container>
      <CustomModal
        show={cloneRepoModal}
        onHide={() => {
          dispatch(setFileContent([]))
          updateClonedRepo()
          setCloneRepoModal(false)}}
        backdrop="static"
        size="lg"
        centered
        heading="Github Repository"
        content={
          <>
            {fileError && <div style={{color: "red"}}>Select atleast one file to proceed</div>}
            <FolderStructure type="github" data={clonedRepo} fileContent={fileContent} setFileContent={setFileContent} githubLink={githubUrl}/>
          </>
        }
        footer={
          <>
            <CustomButton label="Cancel" onClick={() => {
              dispatch(setFileContent([]))
              updateClonedRepo()
              setCloneRepoModal(false)}}/>
            <CustomButton label="Proceed" onClick={() => {
              if(fileContent?.length > 0){
                setFileError(false)
                const updatedFiles = fileContent.map(content => {
                  return new File([content.content], content.name);
                });
                setFile(updatedFiles);
                setEnableGithubClone(false)
                setCloneRepoModal(false)
                updateClonedRepo()
              } else {
                setFileError(true)
              }
            }}/>
          </>
        }
      />
      <CustomModal
        show={showImageModal}
        onHide={() => {
          setShowImageModal(false)
        }}
        backdrop="static"
        size="lg"
        centered
        heading="Images"
        content={
          <div style={{
            height: "500px",
            position: "relative",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
          }}>
            {/* File Input (Hidden) */}
            <input 
              type="file" 
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleImageUpload}
              multiple 
              accept="image/*"
            />

            {images.length > 0 ? (
              <>
                {/* Plus Icon for Adding More Images */}
                <FontAwesomeIcon
                  icon={faPlus}
                  onClick={() => fileInputRef.current.click()}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "20px",
                    cursor: "pointer",
                    fontSize: "24px",
                    color: "#333",
                    zIndex: 10,
                    padding: "10px",
                    backgroundColor: "rgba(255,255,255,0.8)",
                    borderRadius: "50%"
                  }}
                />

                {/* Close Icon */}
                <FontAwesomeIcon
                  icon={faTimes}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "70px",
                    cursor: "pointer",
                    fontSize: "20px",
                    color: "#333",
                    zIndex: 10,
                    padding: "10px",
                    backgroundColor: "rgba(255,255,255,0.8)",
                    borderRadius: "50%"
                  }}
                  onClick={() => handleRemoveImage(currentImageIndex)}
                />

                {/* Left Navigation Arrow */}
                <FontAwesomeIcon
                  icon={faChevronLeft}
                  onClick={handlePrev}
                  style={{
                    position: "absolute",
                    left: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "30px",
                    color: currentImageIndex === 0 ? "#ccc" : "#333",
                    cursor: currentImageIndex === 0 ? "not-allowed" : "pointer",
                    zIndex: 5
                  }}
                />

                {/* Image Display */}
                <img
                  src={images[currentImageIndex]}
                  alt={`Uploaded ${currentImageIndex}`}
                  style={{
                    maxWidth: "80%",
                    maxHeight: "70%",
                    objectFit: "contain",
                  }}
                />

                {/* Right Navigation Arrow */}
                <FontAwesomeIcon
                  icon={faChevronRight}
                  onClick={handleNext}
                  style={{
                    position: "absolute",
                    right: "20px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    fontSize: "30px",
                    color: currentImageIndex === images.length - 1 ? "#ccc" : "#333",
                    cursor: currentImageIndex === images.length - 1 ? "not-allowed" : "pointer",
                    zIndex: 5
                  }}
                />

                {/* Image Name */}
                <span
                  style={{
                    position: "absolute",
                    bottom: "20px",
                    fontSize: "16px",
                    color: "#333",
                    background: "rgba(255, 255, 255, 0.8)",
                    padding: "5px 10px",
                    borderRadius: "5px",
                  }}
                >
                  {/* {images[currentImageIndex]?.name || "Unnamed Image"} */}
                </span>
              </>
            ) : (
              <div 
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <p>No images available</p>
                <FontAwesomeIcon
                  icon={faPlus}
                  onClick={() => fileInputRef.current.click()}
                  style={{
                    cursor: "pointer",
                    fontSize: "48px",
                    color: "#333",
                    padding: "20px",
                    border: "2px dashed #333",
                    borderRadius: "50%",
                    marginTop: "20px"
                  }}
                />
              </div>
            )}
          </div>
        }
      />
      <CustomModal
        show={modalShow}
        onHide={() => {
          setModalShow(false)
        }}
        backdrop="static"
        size="xl"
        centered
        heading="Code Conversion Summary"
        className="conversion-summary-modal"
        icon={FileText}
        content={
          <div className="conversion-summary-content p-4">
            <Row className="g-4">
              {
                fileContent.map(content => content.chunk &&
                  <Col xs={6} key={content.key}>
                    <div className="d-flex flex-column align-items-start summary-cards">
                      {/* Filename */}
                      <div className="filename-text mb-3">{content.name}</div>

                      {/* Cards */}
                      <div className="d-flex w-100 gap-3">
                        <Card className="feature-card d-flex w-50 h-100 position-relative">
                          <Card.Body>
                            <Card.Title className="summary-text">
                              {content.bteqSummary.totalTokens}
                            </Card.Title>
                            <Card.Text className="summary-title">Total Number of Tokens</Card.Text>
                          </Card.Body>
                        </Card>

                        <Card className="feature-card d-flex w-50 h-100 position-relative">
                          <Card.Body>
                            <Card.Title className="summary-text">
                              {content.bteqSummary.noOfChunks}
                            </Card.Title>
                            <Card.Text className="summary-title">Total Number of Chunks</Card.Text>
                          </Card.Body>
                        </Card>
                      </div>
                    </div>
                  </Col>
                )
              }
            </Row>
          </div>
        }
        footer={
          <>
            <CustomButton className="cancel-btn" label="Deny" onClick={() => {
              setModalShow(false)
            }}/>
            <CustomButton className="action-btn" label="Approve" onClick={() => {
              codeConversionChunk()
              setModalShow(false)
            }}/>
          </>
        }
      />
    </div>
  );
}

export default CodeConversion;